import styled from "styled-components";
import { StyledCarousel, StyledNext, StyledPrev } from "src/website-apps/shared/components/carousel/CarouselWithArrows";
import { MatchupCard } from "../MatchupCard";

/**
 * EventsNearYouList
 */
export const StyledEventsNearYouList = styled.div`
  display: grid;
  gap: 16px;
  grid-auto-flow: column;
  grid-auto-columns: minmax(280px, 1fr);
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: ${(props) => props.theme.spacing(5)};
  width: 100%;
`;

/**
 * EventsNearYouCarousel
 */
export const StyledEventsNearYouCarousel = styled.div`
  ${StyledPrev} {
    box-shadow: ${(props) => `0 0 4px 0 ${props.theme.colors.textDarker}`};
    top: 35%;
  }

  ${StyledNext} {
    box-shadow: ${(props) => `0 0 4px 0 ${props.theme.colors.textDarker}`};
    top: 35%;
  }

  ${StyledCarousel} {
    margin-right: ${(props) => props.theme.spacing(4)};
  }
`;

export const StyledMatchupCard = styled(MatchupCard)`
  margin-right: ${(props) => props.theme.spacing(4)};
`;
